import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form'

import Text from './fields/text';
import Select from './fields/select';
import Textarea from './fields/textarea';
import arrows_right from '../../assets/arrows-right.png';
import Isvg from 'react-inlinesvg';

import {
    Container,
    Row,
    Col,
} from 'reactstrap';

const required = value => value ? undefined : "Required"

const renderSelectField = ({
    input,
    placeholder,
    label,
    meta: { touched, error },
    children,
    additionalAction,
    scope,
}) => (

    <Select
        placeholder={placeholder}
        label={label}
        errorText={touched && error}
        error={touched && error}
        additionalAction={additionalAction}
        scope={scope}
        {...input}
        children={children}
    />
)

const renderTextField = ({
    input,
    label,
    placeholder,
    meta: { touched, error },
    type
}) => (

    <Text
        placeholder={placeholder}
        errorText={touched && error}
        label={label}
        error={touched && error}
        type={type}
        {...input}
    />
)

const renderTextareaField = ({
    input,
    placeholder,
    label,
    meta: { touched, error },
}) => (

    <Textarea
        placeholder={placeholder}
        label={label}
        errorText={touched && error}
        error={touched && error}
        {...input}
    />
)


class form extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }



    render() {

        const { handleSubmit, pristine, reset, submitting, menu } = this.props;
        // console.log(pristine, submitting);

        return (
            <form onSubmit={handleSubmit} className="contact-form">
                <Row>
                    <Col lg="6">
                        <div className="field-wrap">
                            <Field
                                name="name"
                                component={renderTextField}
                                label={"Vaše ime".translate(this.props.lang)}
                                placeholder={"Unesite Vaše puno ime".translate(this.props.lang)}
                                validate={[required]}
                            ></Field>
                        </div>
                    </Col>
                    <Col lg="6">
                        <div className="field-wrap">
                            <Field
                                name="phone"
                                component={renderTextField}
                                label={"Vaš telefon".translate(this.props.lang)}
                                placeholder={"Unesite broj telefona".translate(this.props.lang)}
                                validate={[required]}
                            ></Field>
                        </div>
                    </Col>
                    <Col lg="6">
                        <div className="field-wrap">
                            <Field
                                name="email"
                                component={renderTextField}
                                label={"Vaš e-mail".translate(this.props.lang)}
                                placeholder={"Unesite Vašu E-mail adresu".translate(this.props.lang)}
                                validate={[required]}
                            ></Field>
                        </div>
                    </Col>
                    <Col lg="6">
                        <div className="field-wrap">
                            <Field
                                name="title"
                                component={renderTextField}
                                label={"Naslov".translate(this.props.lang)}
                                placeholder={"Unesite naslov Vaše poruke".translate(this.props.lang)}
                                validate={[required]}
                            ></Field>
                        </div>
                    </Col>
                    <Col lg="12">
                        <div className="field-wrap">
                            <Field
                                name="message"
                                component={renderTextareaField}
                                label={"Vaša poruka".translate(this.props.lang)}
                                placeholder={"Unesite Vašu poruku...".translate(this.props.lang)}
                                validate={[required]}
                            ></Field>
                        </div>
                    </Col>

                    <Col lg="12" className="btn-wrap">
                        {this.props.loading ?
                            null
                            :
                            <button className="button">{"POŠALJI UPIT".translate(this.props.lang)}</button>
                        }

                    </Col>
                </Row>


            </form>

        )
    }
}

export default reduxForm({
    form: 'form'  // a unique identifier for this form
})(form)
